
    import React, { Fragment } from 'react';
    
    
    const Markdown = () => (<Fragment><h1 id="february-23rd-2024">February 23rd, 2024</h1>
<h2 id="control-center-v23518">Control Center v2.35.18</h2>
<ul>
<li>In the Agenda Logger there&#39;s a known issue that when you have an Attendee in the editor, when clicking on another Attendee in the left hand coloumn to bring it into the Editor the Fields wont fill with the new information.<ul>
<li>To work around this currently, you can do one of the following:<ul>
<li>Click the Clear Form &#40;or, &quot;X&quot; button&#41; and edit the intended Attendee</li>
<li>Commit edits to the current Attendee and thereby clear the form to edit the intended Attendee</li>
<li>Refresh the page</li>
</ul>
</li>
</ul>
</li>
</ul>
<hr/>
<h1 id="may-19th-2023">May 19th, 2023</h1>
<h2 id="control-center-v23510">Control Center v2.35.10</h2>
<ul>
<li>In the latest release there is a known issue in the Agenda Logger&#39;s PDF export Editor which causes the &quot;Header&quot; or &quot;Footer&quot; draggable elements in the edit pane to not stay where they are dragged to.<ul>
<li>This does not affect the PDF Preview or the Exported document.</li>
</ul>
</li>
</ul>
</Fragment>);
    export default Markdown;
  